import { Link } from "react-router-dom";
import { useModalStore } from "./modalStore";
export default function GlobalModal() {
    const modal = useModalStore((s) => s.modal);
    const closeModal = useModalStore((s) => s.closeModal);
    if (!modal) return null;
    return (
        <div style = {overlayStyle}>
            <div style = {modalStyle}>
                <h3 style = {{ marginTop: 0 }}>{modal.title}</h3>
                <p>{modal.message}</p>
                <p>{modal.organizations?.map((organization) => (
                    <p>
                        <Link
                            key = {organization.id}
                            
                            to = {`/Organizations/${organization.id}`}
                            onClick = {closeModal}
                        >
                            {organization.name} <span className="text-secondary">{organization.website}</span>
                        </Link>
                    </p>
                ))}
                </p>
                <div style = {{ textAlign: "right", marginTop: 20 }}>
                {modal.canCancel?
                <button
                    children = {"Cancel"}
                    type = "button"
                    onClick = {closeModal}
                    className = "btn btn-secondary me-3"
                />
                :null}
                <button
                    children = {modal.confirmText}
                    type = "button"
                    onClick = {() => {
                        modal.onConfirm?.();
                        closeModal();
                    }}
                    className = "btn btn-success"
                />
                </div>
            </div>
        </div>
    );
}
/* -------- styles -------- */
const overlayStyle: React.CSSProperties = {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    };
const modalStyle: React.CSSProperties = {
    background: "#fff",
    padding: "20px 24px",
    borderRadius: 8,
    width: 360,
    maxWidth: "90%",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
};